import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { spacing4, spacing16 } from 'approot/shared/styles/spacing.style';
import { ActivityPosition, POSITION_TOP } from 'global/constants';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const MultipleChoiceImageTextColumn = styled.div`
  ${baseFlexCss}
  height: 100%;
  position: relative;
  width: 50%;
`;

export const MultipleChoiceImageTextInner = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  picture {
    border-radius: ${rem(borderRadius8)};
    overflow: hidden;
  }
`;

type MultipleChoiceTextImageProps = {
  $minHeight: number;
  $imagePosition?: ActivityPosition | null;
};
export const MultipleChoiceImageText = styled.div<MultipleChoiceTextImageProps>`
  ${baseFlexCss}
  position: relative;
  height: 100%;
  width: 100%;
  min-height: ${({ $minHeight }) => rem($minHeight)};

  ${({ $imagePosition }) =>
    $imagePosition === POSITION_TOP
      ? `
        flex-direction: column;
        ${MultipleChoiceImageTextColumn} {
          height: auto;
          width: 100%;
          margin-top: ${rem(spacing4)};
        }
        ${MultipleChoiceImageTextInner} {
          position: relative;
          flex-grow: 1;
          width: 100%;
        }
  `
      : `
    ${MultipleChoiceImageTextColumn} {
      padding-left: ${rem(spacing16)};
    }
    ${MultipleChoiceImageTextInner} {
      left: calc(50% + 4px);
      top: 0;
      bottom: 0;
      right: 0;
    }
  `}
`;
